// src/components/music/hooks/usePurchases.js

import { useState, useEffect, useCallback } from 'react';
import { db } from '../../../firebase';
import { ref as dbRef, onValue, off } from 'firebase/database';

export const usePurchases = (currentUser) => {
  const [purchases, setPurchases] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const userId = currentUser?.uid;

  // Fetch all purchases for the user in real-time
  useEffect(() => {
    if (!userId) {
      setPurchases({});
      return;
    }

    setLoading(true);
    const purchasesRef = dbRef(db, `users/${userId}/purchases`);

    onValue(
      purchasesRef,
      (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setPurchases(data);
        } else {
          setPurchases({});
        }
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching purchases:', err);
        setError(err.message);
        setLoading(false);
      }
    );

    return () => off(purchasesRef);
  }, [userId]);

  // Check if a specific music is purchased
  const isPurchased = useCallback((musicId) => {
    return purchases[musicId] !== undefined;
  }, [purchases]);

  // Get purchase details for a specific music
  const getPurchaseDetails = useCallback((musicId) => {
    return purchases[musicId] || null;
  }, [purchases]);

  // Get all purchased music IDs
  const getPurchasedMusicIds = useCallback(() => {
    return Object.keys(purchases);
  }, [purchases]);

  return {
    purchases,
    loading,
    error,
    isPurchased,
    getPurchaseDetails,
    getPurchasedMusicIds,
  };
};